import { BattleResultModal } from "./BattleResultModal"
import { BattleScreenModal } from "./BattleScreenModal"
import { IBattleResultParams, IBattleScreenParams } from "./types"

export const BATTLE_MODALS = {
  battleScreen: {
    component: BattleScreenModal,
    params: {} as IBattleScreenParams
  },
  battleResult: {
    component: BattleResultModal,
    params: {} as IBattleResultParams
  }
} as const
